// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Volumes/cyssd/cy/work/react/集团官网/src/models/global';
import model_2 from '/Volumes/cyssd/cy/work/react/集团官网/src/models/header';
import model_3 from '/Volumes/cyssd/cy/work/react/集团官网/src/models/home';
import model_4 from '/Volumes/cyssd/cy/work/react/集团官网/src/models/join';
import model_5 from '/Volumes/cyssd/cy/work/react/集团官网/src/models/jtgk';
import model_6 from '/Volumes/cyssd/cy/work/react/集团官网/src/models/news';
import model_7 from '/Volumes/cyssd/cy/work/react/集团官网/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'global', model: model_1 },
model_2: { namespace: 'header', model: model_2 },
model_3: { namespace: 'home', model: model_3 },
model_4: { namespace: 'join', model: model_4 },
model_5: { namespace: 'jtgk', model: model_5 },
model_6: { namespace: 'news', model: model_6 },
model_7: { namespace: '@@initialState', model: model_7 },
} as const
